import menu from './menu'

const menuItems = {
  items: [menu],
}

export default menuItems
